import { STATI_RECLAMO } from "../lib/format";

const STATO = {
  attiva: ["Attiva", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  in_scadenza: ["In scadenza", "bg-amber-50 text-amber-700 border-amber-300"],
  scaduta: ["Scaduta", "bg-red-50 text-red-700 border-red-200"],
  futura: ["Da iniziare", "bg-blue-50 text-blue-700 border-blue-200"],
};

const RECLAMO = {
  aperto: "bg-blue-50 text-blue-700 border-blue-200",
  in_lavorazione: "bg-amber-50 text-amber-700 border-amber-300",
  approvato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  respinto: "bg-red-50 text-red-700 border-red-200",
  chiuso: "bg-slate-100 text-slate-600 border-slate-300",
};

const PIANO = {
  Silver: "bg-slate-100 text-slate-800 border-slate-400",
  Gold: "bg-amber-100 text-amber-900 border-amber-400",
  Platinum: "bg-sky-100 text-sky-900 border-sky-400",
};

const base = "inline-flex items-center gap-1 rounded-sm border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap";

export const StatoBadge = ({ stato, testId }) => {
  const [label, cls] = STATO[stato] || [stato, "bg-slate-100 text-slate-600"];
  return <span data-testid={testId} className={`${base} ${cls}`}>{label}</span>;
};

export const ReclamoBadge = ({ stato, testId }) => (
  <span data-testid={testId} className={`${base} ${RECLAMO[stato] || ""}`}>{STATI_RECLAMO[stato] || stato}</span>
);

export const TipoBadge = ({ g, testId }) =>
  g.tipo === "conformita" ? (
    <span data-testid={testId} className={`${base} bg-slate-800 text-white border-slate-800`}>Conformità {g.durata_mesi}M</span>
  ) : (
    <span data-testid={testId} className={`${base} ${PIANO[g.piano] || "bg-blue-50 text-blue-800 border-blue-300"}`}>
      {g.piano || "Commerciale"}
    </span>
  );
